import React, { useState, useCallback, useRef } from 'react';
import { Wrapper } from '@googlemaps/react-wrapper';

const GOOGLE_MAPS_API_KEY = "AIzaSyBB1thRBxM3w6ugBM1AaRQgbqNVipMByoc";

const MapComponent = ({ onLocationSelect, initialCenter }) => {
  const mapRef = useRef(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const geocoder = useRef(null);

  const initializeMap = useCallback((node) => {
    if (node && !map) {
      const newMap = new window.google.maps.Map(node, {
        center: initialCenter || { lat: 48.8566, lng: 2.3522 }, // Paris par défaut
        zoom: 11,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
        styles: [
          {
            featureType: "poi.business",
            elementType: "labels",
            stylers: [{ visibility: "on" }]
          }
        ]
      });

      // Initialiser le geocoder
      geocoder.current = new window.google.maps.Geocoder();

      // Créer un marqueur
      const newMarker = new window.google.maps.Marker({
        map: newMap,
        draggable: true,
        animation: window.google.maps.Animation.DROP
      });

      // Écouteur de clic sur la carte
      newMap.addListener('click', (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        
        newMarker.setPosition({ lat, lng });
        
        // Géocodage inverse pour obtenir l'adresse
        geocoder.current.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK' && results[0]) {
            onLocationSelect({
              address: results[0].formatted_address,
              lat: lat,
              lng: lng
            });
          } else {
            onLocationSelect({
              address: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
              lat: lat,
              lng: lng
            });
          }
        });
      });

      // Écouteur de drag du marqueur
      newMarker.addListener('dragend', (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        
        geocoder.current.geocode({ location: { lat, lng } }, (results, status) => {
          if (status === 'OK' && results[0]) {
            onLocationSelect({
              address: results[0].formatted_address,
              lat: lat,
              lng: lng
            });
          } else {
            onLocationSelect({
              address: `${lat.toFixed(6)}, ${lng.toFixed(6)}`,
              lat: lat,
              lng: lng
            });
          }
        });
      });

      setMap(newMap);
      setMarker(newMarker);
      mapRef.current = newMap;
    }
  }, [map, onLocationSelect, initialCenter]);

  return (
    <div 
      ref={initializeMap}
      className="w-full h-80 rounded-lg border border-gray-300"
      style={{ minHeight: '320px' }}
    />
  );
};

const MapAddressSelector = ({ onLocationSelect, isOpen, onClose, initialCenter }) => {
  if (!isOpen) return null;

  const handleLocationSelect = (location) => {
    onLocationSelect(location);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-screen overflow-hidden">
        <div className="p-4 border-b border-gray-200 flex justify-between items-center">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              Sélectionner une adresse sur la carte
            </h3>
            <p className="text-sm text-gray-600 mt-1">
              Cliquez sur la carte ou déplacez le marqueur pour choisir un emplacement
            </p>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl font-bold"
          >
            ×
          </button>
        </div>
        
        <div className="p-4">
          <Wrapper apiKey={GOOGLE_MAPS_API_KEY} libraries={['places']}>
            <MapComponent 
              onLocationSelect={handleLocationSelect}
              initialCenter={initialCenter}
            />
          </Wrapper>
        </div>
        
        <div className="p-4 border-t border-gray-200 bg-gray-50">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-600">
              💡 Astuce: Vous pouvez aussi faire glisser le marqueur pour ajuster l'emplacement
            </p>
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition duration-200"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MapAddressSelector;